const accordions = document.querySelectorAll('.accordion-tabs-element');
const buttons = document.querySelectorAll('.accordion-tabs__button');

const closeAccordions = activeAccordion => {
    accordions.forEach(accordion => {
        if (accordion !== activeAccordion) accordion.open = false;
    });
};

const updateButtonStates = () => {
    buttons.forEach(button => {
        const accordion = document.getElementById(button.getAttribute('aria-controls'));
        button.setAttribute('aria-selected', accordion.open ? 'true' : 'false');
    });
};

accordions.forEach(accordion =>
    accordion.addEventListener('toggle', () => {
        const allClosed = [...accordions].every(element => !element.open);

        if (!accordion.open && allClosed) {
            accordion.open = true;
            return;
        }

        closeAccordions(accordion);
        updateButtonStates();
    }),
);

buttons.forEach(button =>
    button.addEventListener('click', () => {
        const accordion = document.getElementById(button.getAttribute('aria-controls'));

        if (!accordion.open) {
            closeAccordions(accordion);
            accordion.open = true;
        }

        updateButtonStates();
    }),
);
